<template>
    <div class="row no-gutters" v-show="show">
        <div class="col-md-12 add-article" v-if="articles.total > 0">
            <router-link to="/mypage/article" class="btn btn-outline-primary">
                <i class="fas fa-edit"></i>
                新規記事を書く
            </router-link>
            <router-link to="/mypage/article?ogp=1" class="btn btn-outline-secondary">
                <i class="fas fa-cloud-download-alt"></i>
                外部記事を読み込む
            </router-link>
        </div>
        <div class="col-md-12">
            <div class="sticky">
                <page :last_page="articles.last_page" v-model="page" @goto="goto"></page>
            </div>
            <div class="row" v-for="(bag, i) in sortedArticles" :key="'article-row-' + i">
                <div class="col-md-4 mb-3" v-for="a in bag" :key="a.id">
                    <article-card
                        :article="a"></article-card>
                </div>
            </div>
            <div class="text-center my-4" v-if="articles.total == 0">
                <div class="position-relative text-center mx-auto" style="max-width: 640px;">
                    <img src="/img/note.png" alt="ノート" class="d-block mx-auto my-5">
                    <h4 class="mb-5">
                        最初の記事を書きましょう。
                    </h4>
                    <div class="small text-muted desc">
                        <p>
                            貸し本棚の記事は、本棚のジャンル欄、シリーズページ、小説ページに表示することができます。
                        </p>
                        <p>
                            作品の設定資料や登場人物紹介、作品解説、あるいは個々の作品とは無関係な創作論や活動記録、
                            自己レビュー、公開メモなどを作成することができます。
                        </p>
                        <p>
                            また、外部投稿サイトで公開しているご自身の記事、作品へリンクを貼ることもできます
                            （OGP対応サイトのみ）。
                        </p>
                    </div>
                    <div class="mb-3">
                        <router-link to="/mypage/article" class="btn btn-outline-primary">
                            <i class="fas fa-edit"></i>
                            新規記事を書く
                        </router-link>
                    </div>
                    <div>
                        <router-link to="/mypage/article?ogp=1" class="btn btn-outline-secondary">
                            <i class="fas fa-cloud-download-alt"></i>
                            外部記事を読み込む
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.cover {
    object-fit: cover;
    height: 100%;
    width: 250px;
}
.article {
    max-height: 250px;
    overflow: hidden;
}
.add-article {
    text-align: right;
    padding: 1rem 0;
}
.badge-light {
    padding: .3rem .7rem;
}
.desc {
    max-width: 480px;
    text-align: left;
    margin: 1rem auto;
}
@media screen and (max-width: 770px) {
    .add-article {
        text-align: center;
    }
}
</style>


<style scoped>
@media screen and (max-width: 770px) {
    .add-button {
        text-align: center;
    }
}
</style>

<script>
import page from "components/Page";
import articleCard from "./articleCard";
export default {
    components: {
        page,
        articleCard,
    },
    data() {
        return {
            articles: {},
            page: this.$route.query.page || 1,
            show: false,
        }
    },
    methods: {
        goto(p) {
            this.page = p;
            this.$router.push({
                query: {
                    page: p
                }
            }).catch(err => {});
            setTimeout(() => {
                this.load();
            });
        },
        load() {
            this.show = false;
            axios.get("/mypage/articles/get", {params: {
                page: this.page
            }}).then(res => {
                this.articles = res.data;
                this.show = true;
            }).catch(err => { alert.err(err) });
        },
    },
    computed: {
        sortedArticles() {
            if (!this.articles || !this.articles.data) return [];
            let articles = [];
            let bag = [];
            for (let i = 0; i < this.articles.data.length; i++) {
                bag.push(this.articles.data[i]);
                if ((i + 1) % 3 === 0) {
                    articles.push(bag);
                    bag = [];
                }
            }
            if (bag) {
                articles.push(bag);
            }
            return articles;
        }
    },
    mounted() {
        this.load();
    }
}
</script>